module.exports = __webpack_public_path__ + "img/map2_empty.f172bc90.png";